export function isTruthyString(o?: any): o is string {
    return typeof o === 'string' && !!o;
}